module.exports = __webpack_public_path__ + "static/media/birra-stela.d8c6b935.svg";